module.exports = __webpack_public_path__ + "static/media/constellation-wide-logo-blank.126f4ff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/constellation-wide-logo-blank.png
// module id = 1706
// module chunks = 0